'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'dumpster';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f793';
var svgPathData = 'M32 64L0 192 106.7 192 132.3 64 32 64zM264 192l0-128-82.7 0-25.6 128 108.3 0zm48 0l108.3 0-25.6-128-82.7 0 0 128zm157.3 0l106.7 0-32-128-100.3 0 25.6 128zM64 240l-37.8 0 6.2 37.3 32 192 1.8 10.7 64.9 0c-2.2-13.3-4.9-29.3-8-48l329.8 0c-3.1 18.7-5.8 34.7-8 48l64.9 0 1.8-10.7 32-192 6.2-37.3-485.8 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDumpster = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;